import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useLayoutEffect, useRef, } from 'react';
import { ToolbarProvider, useToolbarContext } from './context/ToolbarContext';
const border = '1px solid rgb(247, 247, 247)';
const styles = {
    toolbar: (orientation) => {
        return css([
            { display: 'flex', flexWrap: 'wrap' },
            orientation === 'vertical'
                ? {
                    flexDirection: 'column',
                    minHeight: '100%',
                    borderRight: border,
                }
                : {
                    flexDirection: 'row',
                    minWidth: '100%',
                },
        ]);
    },
    item: (active) => {
        return css([
            active && { backgroundColor: 'rgb(247, 247, 247)', borderRadius: 5 },
            {
                width: 30,
                height: 30,
                outline: 'none',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                '&:hover + .content': { display: 'flex' },
            },
        ]);
    },
    tooltip: (orientation, itemOrientation) => {
        const common = {
            display: 'none',
            position: 'absolute',
            backgroundColor: 'gray',
            borderRadius: '2px',
            color: 'white',
            bottom: '0px',
            right: '0px',
            width: 'fit-content',
            height: '50%',
            fontSize: '10px',
            whiteSpace: 'nowrap',
            paddingLeft: '3px',
            paddingRight: '3px',
            zIndex: 50,
        };
        if (itemOrientation === 'auto') {
            return css([
                common,
                orientation === 'vertical' && { margin: 'auto', marginLeft: 5 },
                orientation === 'horizontal'
                    ? { top: '100%' }
                    : { top: '0px', left: '100%' },
            ]);
        }
        else {
            return css([
                common,
                itemOrientation === 'horizontal' && { margin: 'auto', marginLeft: 5 },
                itemOrientation === 'vertical'
                    ? { top: '100%' }
                    : { top: '0px', left: '100%' },
            ]);
        }
    },
};
export function Toolbar(props) {
    const { children, orientation } = props;
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (orientation === 'horizontal') {
            return;
        }
        function update() {
            const lastElement = ref.current?.lastElementChild;
            if (!lastElement) {
                return;
            }
            ref.current.style.width = 'initial';
            const divRect = ref.current.getBoundingClientRect();
            const lastElemRect = lastElement.getBoundingClientRect();
            const width = `${lastElemRect.right - divRect.left}px`;
            if (ref.current.style.width !== width) {
                ref.current.style.width = width;
            }
        }
        const element = ref.current;
        if (element) {
            const observer = new ResizeObserver(update);
            observer.observe(element);
            return () => observer.unobserve(element);
        }
    }, [orientation]);
    return (_jsx("div", { css: styles.toolbar(orientation), ref: ref, children: _jsx(ToolbarProvider, { orientation: orientation, children: children }) }));
}
Toolbar.Item = function ToolbarItem(props) {
    const orientation = useToolbarContext();
    const { active = false, children, onClick, title, titleOrientation = 'auto', id, ...other } = props;
    return (_jsxs("div", { style: { position: 'relative', padding: 4 }, ...other, children: [_jsx("button", { type: "button", css: styles.item(active), onClick: () => {
                    if (onClick) {
                        onClick(props);
                    }
                }, children: children }), _jsx("div", { className: "content", css: styles.tooltip(orientation, titleOrientation), children: _jsx("span", { style: {
                        display: 'flex',
                        margin: 'auto',
                        justifyContent: 'center',
                    }, children: title }) })] }));
};
//# sourceMappingURL=Toolbar.js.map